import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import logo from '../assets/images/logo.png';
import { logout } from './api/loginAPI';
import { setAuthState } from '../assets/scripts/login-util';
import Swal from 'sweetalert2';


const Navbar = (props) => {
    const location = useLocation();

    const handleNavItemClick = () => {
        const navbarToggler = document.querySelector('.navbar-toggler');
        if (navbarToggler && navbarToggler.getAttribute('aria-expanded') === 'true') {
            navbarToggler.click();
        }
    };

    const logoutHandler = async () => {
		try {
			await logout()
			setAuthState();
            window.open('/', '_self');
		} catch (err) {
			window.open('/', '_self');
			Swal.fire({
				icon              : "error",
				titleText         : "Error!",
				text              :  err.message,
				buttonsStyling    : false,
                customClass: {
                    confirmButton: 'btn btn-brand'
                }
			});
		}
	};

    return ( 
        <div className="navbar navbar-expand-lg fixed-top bg-light padding-0" data-bs-theme="light" style={{zIndex: '2'}}>
            <div className="container">
                <a href="https://metromatrixonlineconsultation.in/" target='_blank' className="navbar-brand">
                    <img height="50" className='me-2' src={logo} alt="Metro Matrix Online Consultation"/>
                </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                    <div className="collapse navbar-collapse" id="navbarResponsive">
                    <ul className="navbar-nav me-auto ms-4">
                        <li className="nav-item me-1">
                            <NavLink className="nav-link" to="/dashboard" onClick={handleNavItemClick}>Dashboard</NavLink>
                        </li>
                        <li className="nav-item me-1">
                            <NavLink className="nav-link" to="/mis" onClick={handleNavItemClick}>MIS</NavLink>
                        </li>
                    </ul>
                    <form className='p-2 d-lg-none mx-3' onSubmit={(e) => e.preventDefault()}>
                        {location.pathname === '/dashboard' && (
                            <>
                                <div className='input-group mb-3'>
                                    <span className='input-group-text fs-16'>Test</span>
                                    <select value={props.type} onChange={({ target }) => props.setType(target.value)} className="form-select fs-16">
                                        <option value={'All'}>All</option>
                                        <option value={'VMER'}>VMER</option>
                                        <option value={'TMER'}>TMER</option>
                                    </select>
                                </div>
                                <div className='input-group'>
                                    <span className='input-group-text fs-16'>Status</span>
                                    <select value={props.status} onChange={({ target }) =>props.setStatus(target.value)} className="form-select fs-16">
                                        <option value={'All'}>All</option>
                                        <option value={'Pending'}>Pending</option>
                                        <option value={'Assigned'}>Assigned</option>
                                        <option value={'Scheduled'}>Scheduled</option>
                                        <option value={'QC Pending'}>QC Pending</option>
                                        <option value={'Success'}>Success</option>
                                    </select>
                                </div>
                                <button onClick={handleNavItemClick} type="button" id='btnUpload' data-bs-toggle="modal" data-bs-target="#uploadModal" className="btn btn-info btn-header d-inline-flex align-items-center mt-3 me-2 mb-2">
                                    <i className="bi bi-upload me-2"></i>Upload
                                </button>
                            </>  
                        )}
                        <button onClick={handleNavItemClick} type="button" data-bs-toggle="modal" data-bs-target="#addModal" className="btn btn-primary btn-header d-inline-flex align-items-center mt-3 me-2 mb-2">
                            <i className="bi bi-plus-lg me-2"></i>Add
                        </button>
                        <button type="button" onClick={logoutHandler} className="btn btn-secondary btn-header d-inline-flex align-items-cente mt-3 mb-2">
                            <i className="bi bi-box-arrow-right me-2"></i>Logouts
                        </button>
                    </form>
                    <form className='d-flex d-none d-lg-flex me-1' onSubmit={(e) => e.preventDefault()}>
                        {location.pathname === '/dashboard' && (
                            <button type="button" data-bs-toggle="modal" data-bs-target="#uploadModal" className="btn btn-info btn-header me-sm-2 d-inline-flex align-items-center">
                                <i className="bi bi-upload me-2"></i>Upload
                            </button>
                        )}                          
                        <button type="button" data-bs-toggle="modal" data-bs-target="#addModal" className="btn btn-primary btn-header me-sm-2 d-inline-flex align-items-center">
                            <i className="bi bi-plus-lg me-2"></i>Add
                        </button>
                        <button type="button" onClick={logoutHandler} className="btn btn-secondary btn-header d-inline-flex align-items-center">
                            <i className="bi bi-box-arrow-right me-2"></i>Logout
                        </button>
                    </form>
                </div>
            </div>
        </div>
    )

}

export default Navbar;